export default function NoteTakerIcon({ width = 32, height = 32 }: { width?: number; height?: number }) {
  return (
    <svg width={width} height={height} viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 10C0 4.47715 4.47715 0 10 0H26.0001C31.5229 0 36.0001 4.47715 36.0001 10V26C36.0001 31.5228 31.5229 36 26.0001 36H10C4.47716 36 0 31.5228 0 26V10Z'
        fill='#FFF3E5'
      />
      <path
        d='M18.375 25.5001H22.5C22.8979 25.5001 23.2794 25.342 23.5607 25.0607C23.842 24.7794 24 24.3979 24 24V14.25L20.25 10.5H13.5C13.1022 10.5 12.7206 10.658 12.4393 10.9393C12.158 11.2206 12 11.6022 12 12V19.125'
        stroke='#FB8703'
        stroke-width='1.50001'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M19.5 10.5V13.5C19.5 13.8978 19.658 14.2794 19.9393 14.5607C20.2206 14.842 20.6022 15 21 15H24'
        stroke='#FB8703'
        stroke-width='1.50001'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M19.0328 20.7196C19.1807 20.5717 19.2981 20.3961 19.3781 20.2028C19.4582 20.0095 19.4994 19.8023 19.4994 19.5931C19.4994 19.3839 19.4582 19.1767 19.3781 18.9835C19.2981 18.7902 19.1807 18.6145 19.0328 18.4666C18.8848 18.3187 18.7092 18.2013 18.5159 18.1213C18.3226 18.0412 18.1155 18 17.9063 18C17.6971 18 17.4899 18.0412 17.2966 18.1213C17.1033 18.2013 16.9277 18.3187 16.7798 18.4666L13.0223 22.2256C12.8439 22.4038 12.7134 22.6241 12.6428 22.8661L12.015 25.0186C11.9962 25.0832 11.995 25.1516 12.0117 25.2167C12.0284 25.2818 12.0623 25.3413 12.1098 25.3888C12.1574 25.4363 12.2168 25.4702 12.2819 25.4869C12.3471 25.5036 12.4155 25.5025 12.48 25.4836L14.6325 24.8559C14.8745 24.7852 15.0948 24.6547 15.273 24.4764L19.0328 20.7196Z'
        stroke='#FB8703'
        stroke-width='1.50001'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
